export type IntroLang = 'ru' | 'en' | 'es'

export function useUserLanguage(): IntroLang {
  const browserLang = navigator.language?.slice(0, 2)?.toLowerCase()
  if (browserLang === 'es') return 'es'
  if (browserLang === 'en') return 'en'
  return 'ru'
}
